var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpgradePlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7063 14.4154C21.0647 16.9892 19.4273 19.2028 17.154 20.5696C14.8807 21.9363 12.1577 22.3444 9.58368 21.7041C4.22839 20.3673 0.964152 14.9426 2.29856 9.58848C3.63297 4.23319 9.05298 0.963069 14.4047 2.29865C19.773 3.61659 23.0384 9.05778 21.7063 14.4166V14.4154Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3687 17.8545L11.7958 16.1412M8.94227 15.4293L10.9345 7.43694L8.94227 15.4293ZM9.22115 7.00979L14.141 8.23712C17.3512 9.03729 16.6357 12.7993 13.2161 11.9473C16.9628 12.8817 16.5816 17.3344 12.1488 16.2294C9.98249 15.6882 7.66199 15.1116 7.66199 15.1116L9.22115 7.00979ZM10.0084 11.1483L13.1491 11.9309L10.0084 11.1483ZM11.5052 7.57933L11.9323 5.86719L11.5052 7.57933ZM9.08465 17.285L9.5118 15.5717L9.08465 17.285ZM13.788 8.14886L14.2152 6.43672L13.788 8.14886Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlan);
export default __webpack_public_path__ + "static/media/upgradePlan.18a573ad4db5a7b0a7615cde42df6f7a.svg";
export { ForwardRef as ReactComponent };